import { Col, Row } from 'antd';
import { CustomTable, CustomText, FormInput } from '../../../../components';
import { useMemo, useState } from 'react';

interface GestorTableItemsProps {
  detailData: any;
  columnsBienes: any[];
}

const GestorTableItems = ({
  detailData,
  columnsBienes,
}: GestorTableItemsProps) => {
  const [filterValue, setFilterValue] = useState('');

  // Calculamos los items filtrados dinámicamente
  const filteredItems = useMemo(() => {
    const items = detailData?.items || [];
    if (!filterValue) return items;

    const term = filterValue.toLowerCase();
    return items.filter((item: any) =>
      item?.product_code?.toLowerCase()?.includes(term)
    );
  }, [detailData?.items, filterValue]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterValue(e.target.value);
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <CustomText
            strong={true}
            fontSize="big"
            text={`Listado solicitudes de bienes`}
          />
        </Col>
        <Col span={12}>
          <FormInput
            label="Buscador"
            name="buscador"
            placeholder="Buscar por código de producto..."
            value={filterValue}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          <CustomTable
            columns={columnsBienes}
            dataSource={filteredItems}
            scroll={{ x: 'max-content' }}
            rowKey="id"
          />
        </Col>
      </Row>
    </>
  );
};

export default GestorTableItems;
